import type { ItemStatus, AssetType, InventorySubtype } from "../types";

export function canAssignItem(status: ItemStatus): boolean {
  return status === "in_stock";
}

export function canWriteOffItem(status: ItemStatus): boolean {
  return status === "in_stock" || status === "assigned";
}

export function canReturnItem(status: ItemStatus): boolean {
  return status === "assigned";
}

export function canTransferItem(status: ItemStatus): boolean {
  return status === "assigned";
}

export function isConsumableUnit(assetType: AssetType, inventorySubtype: InventorySubtype): boolean {
  return assetType === "inventory" && inventorySubtype === "consumable";
}

export function canRevalueItem(assetType: AssetType, status: ItemStatus, isDepreciable: boolean): boolean {
  const depreciable = isDepreciable || assetType === "fixed_asset";
  return depreciable && status !== "written_off" && status !== "disposed";
}

export function getWarehouseAvailableActions(
  assetType: AssetType,
  status: ItemStatus,
  isDepreciable?: boolean,
  _inventorySubtype?: InventorySubtype,
): string[] {
  const actions: string[] = ["open"];

  if (canAssignItem(status)) {
    actions.push("assign");
  }

  if (canReturnItem(status)) {
    actions.push("return");
  }

  if (canTransferItem(status)) {
    actions.push("transfer");
  }

  if (canWriteOffItem(status)) {
    actions.push("writeOff");
  }

  if (canRevalueItem(assetType, status, isDepreciable ?? false)) {
    actions.push("revalue");
  }

  return actions;
}
